const aeries = 'Aeries';
const oneRoster = 'OneRoster';
const oneRosterApi = 'OneRosterApiV1';

class SyncScheduleController {
  constructor(agentConfigService) {
    this.name = 'syncSchedule';
    this.uploadHasSucceeded = false;
    this.agentConfigService = agentConfigService;
  }

  submitAgentConfig() {
    let agentConfig = angular.copy(this.agentConfig);
    this.agentConfigService.updateAgentConfig(agentConfig).then(
      this.onUpdateAgentConfigSuccess.bind(this),
      this.onUpdateAgentConfigFailure.bind(this)
    );
  }

  toggleAutosync() {
    let agentConfig = angular.copy({ autoSync: this.agentConfig.autoSync });
    this.agentConfigService.toggleAutoSync(agentConfig).then(
      null,
      this.onUpdateAgentConfigFailure.bind(this)
    );
  }

  onUpdateAgentConfigSuccess() {
    this.uploadHasSucceeded = true;
  }

  isAeriesCustomer() {
    return (this.agentConfig.format === aeries);
  }

  isOneRosterCustomer() {
    return (this.agentConfig.format === oneRoster);
  }

  isOneRosterApiCustomer() {
    return (this.agentConfig.format === oneRosterApi);
  }

  onUpdateAgentConfigFailure() {
    console.log('There was an error updating your agent configuration.');
  }
}

SyncScheduleController.$inject = ['agentConfigService'];

export default SyncScheduleController;



// WEBPACK FOOTER //
// ./app/components/syncSchedule/syncSchedule.controller.js